import urljoin from 'url-join'
import ServicesUtils from '@/utils/servicesUtils'
import StringUtils from '@/utils/stringUtils'

export default
{
    namespaced: true,
    
    state:
    {
        reportsList: [],
        tags: []
    },

    getters:
    {
        getReportById: state => id =>
        {
            return state.reportsList.find(r => r.id == id)
        }
    },
    
    mutations:
    {
        updateReportsList (state, reports) 
        {
            let currentList = state.reportsList
            
            for (let report of reports)
            {
                let reportWithSameId = currentList.find(r => r.id == report.id)
                if (reportWithSameId)
                {
                    report = Object.assign({}, reportWithSameId, report)
                    currentList.splice(currentList.indexOf(reportWithSameId), 1)
                }

                if (!report.pictureUrl.includes('http') && !StringUtils.isEmptyString(report.pictureUrl))
                {
                    report.pictureUrl = urljoin(ServicesUtils.cdnUrl, report.pictureUrl)
                }

                currentList.push(report)
            }

            currentList = currentList.sort((a, b) =>
            {
                let dDate = new Date(b.date) - new Date(a.date)
                let dId = b.id - a.id

                return dDate + dId
            })

            state.reportsList = currentList
        },

        setTags (state, tags) 
        {
            state.tags = tags
        }
    },

    actions:
    {
        removeReportById ({ getters, state }, id)
        {
            let report = getters.getReportById(id)
            
            if (!report) return
            
            const reports = state.reportsList
            reports.splice(reports.indexOf(report), 1)

            state.reportsList = reports
        }
    }
}


// WEBPACK FOOTER //
// ./src/stores/reports.js